const header = {
  organisationLocation: 'Organización - Ubicación',
  organisation: 'Organización',
  location: 'Location',
  quickAction: 'Ubicación',
  addAppointment: 'Agregar cita',
  addPatient: 'Agregar paciente',
  addTask: 'Agregar tarea',
  startCall: 'Iniciar llamada',
  notification: 'Notificación',
  checkAllNotifications: 'Ver todas las notificaciones',
  myProfile: 'Mi perfil',
  settings: 'Ajustes',
  logout: 'Cerrar sesión'
}


export default header
